// extracted by mini-css-extract-plugin
export var branding = "header-module--branding--i2gkj";
export var nav = "header-module--nav--e8OJ3";
export var root = "header-module--root--KGdif";
export var showNav = "header-module--showNav--Q9H09";
export var toggleNavButton = "header-module--toggleNavButton--r2rxY";
export var wrapper = "header-module--wrapper--uoQUP";